import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./assets/scss/styles.scss";

import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Error404 from "./components/Error404";
import BannerGate from "./components/Slider/BannerGate";
import Formulario from "./components/Formulario/Formulario";
import TagManager from "react-gtm-module";
import { LandingConfigProvider } from "./context/OpenDoorEventContext";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminPanel from "./pages/admin/AdminPanel";
import ProtectedRoute from "./pages/admin/ProtectedRoute";
import { persistUtmsFromUrl } from "./utils/utm";

const tagManagerArgs = {
  gtmId: "G-2EHWB07T0K",
};

TagManager.initialize(tagManagerArgs);
persistUtmsFromUrl();

function EventosLanding() {
  return (
    <LandingConfigProvider>
      <div className="site-layout">
        <main className="site-layout__main">
          <BannerGate />
          <Formulario />
        </main>
        <Footer />
      </div>
    </LandingConfigProvider>
  );
}

function App() {
  window.dataLayer.push({
    event: "pageview",
  });
  return (
    <div className="app-root">
      <Router basename="/eventos">
        <div className="app-root__router">
          <Switch>
            <Route exact path="/">
              <EventosLanding />
            </Route>

            <Route exact path="/admin/login">
              <AdminLogin />
            </Route>

            <ProtectedRoute exact path="/admin" component={AdminPanel} />

            <Route path="*">
              <div className="site-layout">
                <main className="site-layout__main">
                  <Header bg="bgDark" />
                  <Error404 />
                </main>
                <Footer />
              </div>
            </Route>
          </Switch>
        </div>
      </Router>
    </div>
  );
}

export default App;
